window.addEventListener("hoContentLoaded", () => {


Vue.component('ho-lane', {
	data() {
		return {
			lane:null,
			wrapper:null,
			totalWidth: 0,
			showPrev: false,
			showNext: true,
			isDragging: false,
			startPosition:"left",
			startX: 0,
			lastWalk: 0,
			dragDistance: 0,
			scrollLeft: 0
		}
	},

	computed: {
		currentScrollPercent() {
			let ret = 0;
			if (this.totalWidth > 0) {
				ret = ((this.scrollLeft)/ (this.totalWidth)) * 100;
			}

			console.log("currentScrollPercent:",ret);

			return ret;
		},
		prefersReducedMotion()
		{
			return store.getters['settings/prefersReducedMotion'];
		},
	},

	methods: {
		prev()
		{
			const distance = this.calculateDistance('prev');
			this.scrollTo(this.lane.scrollLeft - distance);
		},

		next()
		{
			const distance = this.calculateDistance('next');
			this.scrollTo(this.lane.scrollLeft + distance);
		},

		calculateDistance(direction) {
			// Annahme: this.childs ist bereits eine Liste aller Items.
			let currentItemIndex = 0;
			let currentScroll = this.lane.scrollLeft;

			// Gesamtbreite bis zum aktuellen Item berechnen
			let totalWidthUntilCurrentItem = 0;
			for (let i = 0; i < this.childs.length; i++) {
				totalWidthUntilCurrentItem += this.childs[i].offsetWidth;
				if (totalWidthUntilCurrentItem >= currentScroll) {
					currentItemIndex = i;
					break; // Stop the loop once we found the current item
				}
			}

			// Breite des aktuellen Items ermitteln
			let currentItemWidth = this.childs[currentItemIndex].offsetWidth;

			return currentItemWidth;
		},

		onScroll() {
			this.updateButtons();
		},

		onResize() {
			this.totalWidth = Array.from(this.lane.children).reduce((acc, child) => acc + child.offsetWidth, 0);
			this.updateButtons();
		},

		updateButtons() {
			this.showPrev = this.lane.scrollLeft > 0;
			this.showNext = this.lane.scrollLeft < (this.totalWidth - this.lane.clientWidth);
		},

		scrollTo(position) {
			gsap.to(this.lane, {
				scrollTo: {
					x: position,
					autoKill: true
				},
				duration: 1.3,
				ease: "expo.out",
				onStart: this.start,
				onComplete: this.complete
			});
		},

		start()
		{
			this.isDragging = false;
			this.lane.classList.add("is-animating");
		},

		complete()
		{
			this.lane.classList.remove("is-animating");
			this.updateButtons();
		},

		onMouseDown(e) {
			this.isDragging = true;
			this.dragDistance = 0;
			this.lastWalk = 0;
			this.startX = e.pageX - this.lane.offsetLeft;
			this.scrollLeft = this.lane.scrollLeft;
			this.lane.classList.add('is-animating');
		},
		onMouseLeave() {
			this.isDragging = false;
			this.lane.classList.remove('is-animating');

		},
		onMouseUp(e) {
			if (this.isDragging && this.dragDistance > 5) { // Nehmen Sie 5 Pixel als Schwellenwert
				e.preventDefault();
				e.stopPropagation();
				e.stopImmediatePropagation();
			}

			this.lane.classList.remove('pointer-events-none-while-dragging');

			this.isDragging = false;
			this.dragDistance = 0;
			this.lastWalk = 0;
			this.lane.classList.remove('is-animating');
		},

		onMouseMove(e) {
			if (!this.isDragging)
				return;
			e.preventDefault();


			const x = e.pageX - this.lane.offsetLeft;
			const walk = x - this.startX;
			const walkChange = walk - this.lastWalk;
			this.dragDistance += Math.abs(walkChange);
			this.lastWalk = walk;

			if (this.dragDistance > 5 && !this.lane.classList.contains('pointer-events-none-while-dragging')) {
				this.lane.classList.add('pointer-events-none-while-dragging');
			}

			this.lane.scrollLeft = this.scrollLeft - walk;
		}
	},

	beforeDestroy() {
		this.lane.removeEventListener('scroll', this.onScroll);
		window.removeEventListener('resize', this.onResize);

		this.lane.removeEventListener('mousedown', this.onMouseDown);
		this.lane.removeEventListener('mouseleave', this.onMouseLeave);
		this.lane.removeEventListener('mouseup', this.onMouseUp);
		this.lane.removeEventListener('mousemove', this.onMouseMove);
	},

	mounted() {
		this.lane = this.$el.querySelector(".wp-block-ho-lane");
		this.childs = this.$el.querySelectorAll(".wp-block-ho-lane-item");

		this.wrapper = this.$el.querySelector(".wp-block-ho-lane-wrapper");
		this.totalWidth = Array.from(this.lane.children).reduce((acc, child) => acc + child.offsetWidth, 0);
		this.updateButtons();

		if(this.$el.querySelector("[data-start-position]"))
		{
			if(this.$el.querySelector("[data-start-position]").dataset.startPosition === "center")
				this.startPosition = "center";
		}

		if (this.startPosition === "center") {
			const halfWidth = this.totalWidth / 2;
			const centerPosition = halfWidth - (this.lane.clientWidth / 2);
			this.scrollLeft = this.lane.scrollLeft = centerPosition;
		}

		this.lane.addEventListener('scroll', this.onScroll);
		window.addEventListener('resize', this.onResize);

		this.lane.addEventListener('mousedown', this.onMouseDown);
		this.lane.addEventListener('mouseleave', this.onMouseLeave);
		this.lane.addEventListener('mouseup', this.onMouseUp);
		this.lane.addEventListener('mousemove', this.onMouseMove);
	}
});
});
